import { Injectable } from "@angular/core";
import { PaymentAction, PaymentInfo } from "../../interfaces/payment.interface";
import { LoggingService } from "../log.service";
import { RestfulService } from "../restful.service";
import { RequestBody } from "../../interfaces/admin.interface";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { getEndPointWithParams } from '../../../../assets/js/util.js';
import * as ENDPOINT from "../../../shared/constant/endPoint.js";
import { UtilsService } from "../utils.service";

@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    typeActionPayment: PaymentAction;

    constructor(
        private logger: LoggingService,
        private restful: RestfulService,
        private utils: UtilsService
    ) { }

    setTypeActionPayment(paymentAction: PaymentAction) {
        this.typeActionPayment = paymentAction;
    }

    getTypeActionPayment(): PaymentAction {
        return this.typeActionPayment;
    }

    getPaymentsList(reqBody: RequestBody): Observable<any> {
        const endPoint = ENDPOINT.payment_all;
        return this.post(endPoint, reqBody);
    }

    getPaymentInfo(paymentId: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.payment_info, paymentId);
        return this.get(endPoint);
    }

    createPayment(reqBody: PaymentInfo): Observable<any> {
        return this.post(ENDPOINT.payment_create, reqBody);
    }

    editPayment(reqBody: PaymentInfo): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.payment_update);
        return this.post(endPoint, reqBody);
    }

    duplicatePayment(paymentId: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.payment_duplicate, paymentId);
        return this.get(endPoint);
    }

    togglePaymentState(paymentId: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.payment_toggle, paymentId);
        return this.put(endPoint);
    }

    /* RESTFUL METHOD */

    post(endPoint: string, reqBody: any, localhost: boolean = false): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.post(endPoint, reqBody).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    put(endPoint: string): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.put(endPoint, null).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    delete(endPoint: string): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.delete(endPoint).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    get(endPoint: string): Observable<any> {
        return Observable.create((observer: any) => {
            this.restful.get(endPoint).subscribe((response: any) => {
                this.responseHandler(response, observer);
            });
        });
    }

    responseHandler(response: HttpResponse<any>, observer: any): void {
        const outcome = response["outcome"];
        if (outcome.success === true) {
            this.logger.log("Service:", "SUCCESS", 200);
            observer.next(response);
        } else {
            this.logger.log("Service:", "FAILURE", 200);
            outcome.message = this.utils.manageErrorMsg(outcome);
            observer.error(outcome);
        }
    }

}
